import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import useModalStore from "store/modals";
import { useAllUnits } from "http-hooks/unit/useUnit";

const SelectUnits = ({
  value,
  onChange,
  placeholder = "Search unit of measurement...",
  isDisabled = false,
  isRequired = false,
  label = "Unit of Measurement",
  className = "",
  filters = {},
  unitidunder = 1,
  showLabel = true,
  showAddButton = true, // New prop to control plus button visibility
}) => {
  const { openModal } = useModalStore();
  
  const {
    isLoading: isLoadingAllUnits,
    data: { data: allUnits } = [],
  } = useAllUnits({
    unitidunder,
    noPagination: true,
    ...filters,
  });

  // Convert units to options for Select component
  const unitOptions = allUnits?.map(unit => ({
    value: unit.unitId,
    label: unit.unitname,
    unitname: unit.unitname,
    ...unit
  })) || [];

  const handleAddNew = () => {
    openModal('unit');
  };

  return (
    <div>
      {showLabel && (
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {label}
          </label>
          {showAddButton && !isDisabled && (
            <button
              type="button"
              onClick={handleAddNew}
              className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
              title="Add new unit"
            >
              <PlusIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={unitOptions}
        getOptionValue={(option) => option?.value}
        getOptionLabel={(option) => option?.label}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoadingAllUnits}
        isRequired={isRequired}
        label={label}
        className={className}
        showLabel={false}
        isClearable={true}
        isSearchable={true}
      />
      {!showLabel && showAddButton && !isDisabled && (
        <button
          type="button"
          onClick={handleAddNew}
          className="absolute top-0 right-0 h-10 w-10 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
          title="Add new unit"
        >
          <PlusIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SelectUnits; 